import PageHeader from "src/components/PageHeader";
import OrderCard from "./components/OrderCard";
import { useContext, useEffect, useState } from "react";
import { getData } from "src/actions/getData";
import Skeleton from "react-loading-skeleton";
import processingContext from "src/context/processingContext";
import { expressShippingTitle } from "src/settings/config";

export default function InstantOrders() {
    const [InstantOrders, setInstantOrders] = useState(false)

    const { processingOrders, setProcessingOrders } = useContext(processingContext)

    useEffect(() => {
        const controller = new AbortController(); // برای لغو درخواست
        const signal = controller.signal;

        if (!processingOrders) {
            getData(setProcessingOrders, "/orders/by-status/processing", {}, signal);
        }

        return () => {
            controller.abort();
        };
    }, [])

    useEffect(() => {
        if (processingOrders) {
            setInstantOrders(processingOrders.filter(order => {
                
                
                if (order?.shipping?.[0]?.methodName == expressShippingTitle) {
                    return true
                }
            }))
        }
    }, [processingOrders])


    return (
        <>
            <PageHeader
                btnTitle={`${InstantOrders.length || "-"} سفارش`}
                title="سفارشات ارسال فوری"
            />

            {
                InstantOrders
                    ?
                    InstantOrders.length > 0
                        ?
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-3">
                            {InstantOrders.sort((a, b) => a.id - b.id).map((order, index) => {
                                return (
                                    <OrderCard order={order} type="instant" key={index} />
                                )
                            })}
                        </div>
                        :
                        <div className="w-full h-60 flex justify-center items-center bg-white p-4 rounded-xl">هیچ سفارش فوری وجود ندارد</div>
                    :
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-3">
                        <Skeleton height={430} className="!rounded-xl" />
                        <Skeleton height={430} className="!rounded-xl" />
                        <Skeleton height={430} className="!rounded-xl" />
                        <Skeleton height={430} className="!rounded-xl" />
                        <Skeleton height={430} className="!rounded-xl" />
                        <Skeleton height={430} className="!rounded-xl" />
                        <Skeleton height={430} className="!rounded-xl" />
                        <Skeleton height={430} className="!rounded-xl" />
                    </div>
            }
        </>
    )
}